import { Row, Typography } from "antd";

const Partners = () => {
  return (
    <Row className="py-16 max-lg:px-4 max-lg:py-8 max-w-screen">
      <Typography.Title
        level={2}
        className="mx-auto pb-8 underline underline-offset-8 decoration-[#B91C1C] font-medium max-md:text-[25px]"
      >
        Our Partners and Collaborators
      </Typography.Title>
      <section className="logoMarqueeSection max-w-full">
        <div className="container" id="logoMarqueeSection">
          <div className="flex items-center default-content-container">
            <div className="relative inline-block overflow-hidden default-content-container-inner marquee-wrapper">
              <div className="marquee" style={{ animationDuration: "57s" }}>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/AL.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/bussman.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/fenesta.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/genpact.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/ITC-Hotels.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/jcbl.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/komatsu.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/mahindra.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/marcopolo.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/mg.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/shavo.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
              </div>
              <div className="marquee" style={{ animationDuration: "57s" }}>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/AL.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/bussman.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/fenesta.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/genpact.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/ITC-Hotels.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/jcbl.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/komatsu.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/mahindra.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/marcopolo.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/mg.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
                <div>
                  <img
                    alt=""
                    src="/assets/brand-logos/shavo.png"
                    title=""
                    className="marqueelogo border-0"
                    style={{ width: "auto", maxWidth: "none" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Row>
  );
};
export default Partners;
